import { render, staticRenderFns } from "./OrmUtilitiesView.vue?vue&type=template&id=3aa3c22d&scoped=true"
import script from "./OrmUtilitiesView.vue?vue&type=script&lang=js"
export * from "./OrmUtilitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3c22d",
  null
  
)

export default component.exports